import type { CastProfile } from './castProfiles.ts'
import type { CastProfileTimeline } from './castProfileTimelines.ts'

// Individualized newcomer stories, reviewed October 1, 2026.
// A retreat conversation or another participant's recollection of interest is
// not a verified relationship. Exact episode appearances remain unverified.
export const finalHuntProfilesCE: CastProfile[] = [
  {
    personId: 'p-chris-90-day-hunt-for-love-s1',
    headline: 'A new retreat single whose hot-tub small talk took an unexpected detour through an ex.',
    bio: [
      'Chris entered Hunt for Love as one of TLC’s new singles, rather than arriving with an established 90 Day couple storyline. A published premiere recap identifies him as Chantel’s hot-tub speed dater and describes him asking how her ex would react to seeing her there. The conversation turned to Pedro—a surprisingly full agenda for a very short date.',
      'His retreat story was not limited to that conversation. In a later Pink Shade interview, fellow participant Elise Benson recalled that Jeniffer had been interested in Chris. That is Elise’s recollection of attraction, not confirmation that they dated; a crush does not come with an automatically issued couple badge. A lasting on-show match and his current relationship status remain unverified.',
    ],
    originStory: 'TLC introduced Chris among the new singles joining Hunt for Love Season 1. He entered the retreat independently to meet potential dates, not as Chantel’s or Jeniffer’s established partner.',
    journeys: [
      {
        label: 'Where it started: a singles-retreat introduction',
        era: 'Hunt for Love S1',
        summary: 'Chris joined independently, with a premiere recap identifying his speed-date conversation with Chantel. Elise later recalled Jeniffer’s interest in him, but neither account establishes an original couple or a verified current partner.',
      },
    ],
    sources: [
      {
        label: 'TLC: Chris among the new retreat singles',
        url: 'https://www.tlc.com/shows/90-day-hunt-for-love/meet-the-90-day-hunt-for-love-singles-retreat-hopefuls',
      },
      {
        label: 'TV Season & Spoilers: reported Chris and Chantel conversation',
        url: 'https://www.tvseasonspoilers.com/news/90-day-fiance-chantel-says-pedro-owes-her-money/',
      },
      {
        label: 'TLC’s official hot-tub speed-date preview',
        url: 'https://www.instagram.com/reel/DKI6FONsfIK/',
      },
      {
        label: 'Pink Shade: Elise Benson’s firsthand retreat recollections',
        url: 'https://www.iheart.com/podcast/256-pink-shade-reality-tv-with-31116932/episode/1020-bonus-interview-with-elise-291509155/',
      },
    ],
  },
]

export const finalHuntTimelinesCE: Record<string, CastProfileTimeline> = {
  'p-chris-90-day-hunt-for-love-s1': {
    origin: {
      partnerName: 'Joining the retreat independently',
      introLabel: 'A new single in Tulum',
      show: '90 Day: Hunt for Love',
      season: 1,
      connectionKind: 'independent',
    },
    connections: [
      {
        name: 'Chantel Everett',
        personId: 'p-chantel-everett',
        context: 'Identified as his hot-tub speed-date conversation partner in a published premiere recap, not a verified lasting relationship.',
      },
      {
        name: 'Jeniffer Tarazona',
        personId: 'p-jeniffer-tarazona',
        context: 'Elise Benson later recalled Jeniffer being interested in Chris. This is an attributed recollection, not confirmation that they dated.',
      },
    ],
    seasons: [
      {
        show: '90 Day: Hunt for Love',
        season: 1,
        title: 'A speed-date detour—and an attributed crush',
        recap: 'A premiere recap describes Chris’s hot-tub conversation with Chantel turning to her ex after his question. Elise later recalled Jeniffer’s interest in him, but a confirmed romantic pairing or post-retreat outcome is not established.',
        status: 'aired',
      },
    ],
  },
}
